import React from 'react';

// Plain secondary button, placed inside the existing auth forms.
const GoogleSignInButton = ({ label, onClick, disabled, busy }) => (
  <div className="auth-google">
    <div className="auth-divider">or</div>
    <button
      type="button"
      className="btn btn-secondary btn-full"
      onClick={onClick}
      disabled={disabled || busy}
    >
      {busy ? 'Signing in...' : label}
    </button>
  </div>
);

export const GoogleAccountNote = ({ email, onUseDifferent }) => (
  <div className="auth-google-note">
    <p>Signed in with Google as {email}. Finish this form to create your account.</p>
    <button type="button" className="auth-text-button" onClick={onUseDifferent}>
      Use a different account
    </button>
  </div>
);

export default GoogleSignInButton;
